import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Confirm, crudUpdateMany,  crudUpdate, useUpdate} from 'react-admin';
import PublishIcon from '@material-ui/icons/Clear';
import {DataStatus} from '../../util/constant'

class WalletResetButton extends Component {
    state = {
        isOpen: false,
        record: {validated: false},
    }

    // constructor(props){
    //     super(props);
    //     const {record} = this.props
    //     this.setState({validated: record.validated});
    //     console.log('Validate button state ' + JSON.stringify(this.state));
    // }

    // componentDidUpdate(prevProps, prevState) {
    //     if(prevProps.record!==this.props.record){
    //       this.setState({record: this.props.record});
    //     }
    //   }

    //   static getDerivedStateFromProps(nextProps, prevState){
    //     if(nextProps.record !== prevState.record){
    //       return {record : nextProps.record};
    //     }
    //     else return null;
    //   }

    handleClick = () => {
        this.setState({ isOpen: true });
    }

    handleDialogClose = () => {
        this.setState({ isOpen: false });
    };

    handleConfirm = () => {
        console.log("Handle button props " + JSON.stringify(this.props));
        const { basePath, crudUpdate, resource, record } = this.props;
        // crudUpdate(resource, record.id, {validated: 1}, basePath + '/' + record.id + '/show');
        crudUpdate('wallet', record.wallet.id, {balance: 0}, basePath, 'show', true);
        this.setState({ isOpen: false });
    };

    static defaultProps = {
        // confirmTitle: 'Validation',
        // confirmMessage: 'Are you sure to mark these objects as handled?',
        // validated: DataStatus.APPROVED,
      }
    

    render() {
        // let message = "Ce message sera envoyé aux chauffeurs/clients choisis. Êtes-vous sûr de vouloir publier ce message?";
        return (
            <Fragment>
            {typeof(this.state.record) !== 'undefined' && !this.state.record.balance > 0 && 
                <Button label='Réinitialiser' onClick={this.handleClick}>
                    <PublishIcon color='primary'/>
                </Button>}
                <Confirm
                    isOpen={this.state.isOpen}
                    title={this.props.confirmTitle}
                    content={this.props.content}
                    onConfirm={this.handleConfirm}
                    onClose={this.handleDialogClose}
                />
            </Fragment>
        );
    }
    // handleClick = () => {
    //     const { push, record, showNotification } = this.props;
    //     const updatedRecord = { ...record, is_approved: true };
    //     fetch(`/comments/${record.id}`, { method: 'PUT', body: updatedRecord })
    //         .then(() => {
    //             showNotification('Comment approved');
    //             push('/comments');
    //         })
    //         .catch((e) => {
    //             showNotification('Error: comment not approved', 'warning')
    //         });
    // }

    // render() {
    //     return <Button label="Approve" onClick={this.handleClick} />;
    // }
    
}

// BatchHandleButton.propTypes = {
//     confirmTitle: PropTypes.string,
//     confirmMessage: PropTypes.string,
    
// };

export default connect(undefined, { crudUpdate })(WalletResetButton);
// export default ValidateButton;

// HandleButton.propTypes = {
//     push: PropTypes.func,
//     record: PropTypes.object,
//     showNotification: PropTypes.func,
// };

// export default connect(null, {
//     showNotification,
//     push,
// })(HandleButton);